import { render, staticRenderFns } from "./ReviewMain.vue?vue&type=template&id=26353adb"
import script from "./ReviewMain.vue?vue&type=script&lang=js"
export * from "./ReviewMain.vue?vue&type=script&lang=js"
import style0 from "./ReviewMain.vue?vue&type=style&index=0&id=26353adb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports